import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Popover, Chip, Radio } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './FilterPapers.css';
import { MainContext } from '../../../../../../context/main/main-context';
import SimpleReactValidator from "simple-react-validator";
import Type from '../../../../subscription/Type';


const filterKeyMap = {
  Subject: { idKey: "subject_id", labelKey: "subject" },
  Grade: { idKey: "grade_id", labelKey: "grade" },
  Status: { idKey: "status_id", labelKey: "status" },
  Source: { idKey: "source_id", labelKey: "source" },
  Author: { idKey: "author_id", labelKey: "author" },
  Category: { idKey: "category_id", labelKey: "name" },
  Exam_Category: { idKey: "exam_category_id", labelKey: "name" },
  Chapter: { idKey: "chapter_id", labelKey: "chapter" },
  Difficulty: { idKey: "difficulty_id", labelKey: "difficulty_type" },
  Language: { idKey: "language_id", labelKey: "language" },
  Created_By: { idKey: "user_id", labelKey: (item) => `${item.first_name} ${item.last_name}` },
  Reviewers: { idKey: "user_id", labelKey: (item) => `${item.first_name} ${item.last_name}` },
  Term: { idKey: "term_id", labelKey: "term" },
  Exam_Status: { idKey: "exam_status_id", labelKey: "exam_status" },
  Year: { idKey: "year_id", labelKey: "year" },
  Type: { idKey: "type_id", labelKey: "qtype"}
};


export default function FilterPanel({
  userType, selectedFilters, setSelectedFilters,
  filterOptions, setFilterOptions, visibleFilterOptions, isShowExamStatus
}) {



  const [anchorEl, setAnchorEl] = useState(null);
  const [currentDropdown, setCurrentDropdown] = useState('');
  const [showAllChips, setShowAllChips] = useState({});
  const [, forceUpdate] = useState(); // Used to force re-renders for the validator

  const handleOpen = (event, filterType) => {
    setAnchorEl(event.currentTarget);
    setCurrentDropdown(filterType);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setCurrentDropdown('');
  };

  const handleToggle = (filterType, value) => {

    if (filterType === "Exam_Status") {
      setSelectedFilters({
        ...selectedFilters,
        [filterType]: [value]
      });
    } else {
      const current = selectedFilters[filterType] || [];
      const updated = current.includes(value)
        ? current.filter((item) => item !== value)
        : [...current, value];

      setSelectedFilters({
        ...selectedFilters,
        [filterType]: updated
      });
    }
  };


  const handleDeleteChip = (filterType, value) => {
    const updatedFilters = {
      ...selectedFilters,
      [filterType]: selectedFilters[filterType].filter((item) => item !== value)
    };

    setSelectedFilters(updatedFilters);
  };

  const handleClearAll = () => {
    const cleared = {};
    Object.keys(selectedFilters).forEach((key) => {
      if (isShowExamStatus && key === "Exam_Status") {
        cleared[key] = selectedFilters[key];
      } else {
        cleared[key] = [];
      }
    });
    setSelectedFilters(cleared);
  };

  const toggleShowAllChips = (filterType) => {
    setShowAllChips(prev => ({
      ...prev,
      [filterType]: !prev[filterType]
    }));
  };

  const open = Boolean(anchorEl);
  
const [validator] = useState(
  new SimpleReactValidator({
    messages: {
      className: 'srv-validation-message',
      required: "This field is required.",
      before: "Start date must be before end date.",
      after: "End date must be after start date.",
    },
    validators: {
      before: {
        message: 'Start date must be before end date.',
        rule: (val, params, validator) => {
          if (!val || !params[0]) return true; // skip if any empty
          const startDate = new Date(val);
          const endDate = new Date(params[0]);
          return startDate <= endDate;
        }
      },
      after: {
        message: 'End date must be after start date.',
        rule: (val, params, validator) => {
          if (!val || !params[0]) return true; // skip if any empty
          const startDate = new Date(params[0]);
          const endDate = new Date(val);
          return endDate >= startDate;
        }
      }
    }
  })
);

const handleStartDateChange = (event) => {
  const date = event.target.value;
  const formattedDate = date ? date.replace(/-/g, "") : null;
  const newFilters = { 
    ...selectedFilters, 
    StartDate: formattedDate, 
    StartDateRaw: date 
  };
  setSelectedFilters(newFilters);
  validator.showMessageFor("StartDate");
};

const handleEndDateChange = (event) => {
  const date = event.target.value;
  const formattedDate = date ? date.replace(/-/g, "") : null;
  const newFilters = { 
    ...selectedFilters, 
    EndDate: formattedDate, 
    EndDateRaw: date 
  };
  setSelectedFilters(newFilters);
  validator.showMessageFor("EndDate");
};


  return (
    <div className="ph-filter-panel-modern">
      <span className="filter-title">Filters</span>

      <hr className="ph-divider" />

            <div className="text-end mb-3">
              <button className="ph-clear-btn" onClick={handleClearAll}>Clear all added filters</button>
            </div>
           {(visibleFilterOptions.includes("StartDate") || visibleFilterOptions.includes("EndDate")) && (
              <div className="text-end mb-3">
                <label style={{ marginRight: "10px" }}>
                  Start Date:&nbsp;
                  <input
                      type="date"
                      value={selectedFilters.StartDateRaw || ""}
                      onChange={handleStartDateChange}
                    />
                    {validator.message("StartDate", selectedFilters.StartDateRaw, `before:${selectedFilters.EndDateRaw}`)}

                </label>

                <label>
                  End Date:&nbsp;&nbsp;&nbsp;
                     <input
                      type="date"
                      value={selectedFilters.EndDateRaw || ""}
                      onChange={handleEndDateChange}
                    />
                    {validator.message("EndDate", selectedFilters.EndDateRaw, `after:${selectedFilters.StartDateRaw}`)}
                </label>
              </div>
            )}

       {userType && visibleFilterOptions
        ?.filter(filterType => filterType !== 'StartDate' && filterType !== 'EndDate' && (isShowExamStatus || filterType !== "Exam_Status"))
        .map((filterType) => {
          const isActive = selectedFilters[filterType]?.length > 0;

          return (
            <>
            
              <div className="mb-3 d-flex flex-wrap gap-2">
                {(() => {
                  const totalOptions = filterOptions[filterType]?.length || 0;
                  const selectedCount = selectedFilters[filterType]?.length || 0;

                  // Check if all options are selected
                  if (totalOptions > 0 && selectedCount === totalOptions) {
                    return (
                      <Chip
                        key={`${filterType}-all-selected`}
                        label="All selected"
                        onDelete={() => setSelectedFilters({ ...selectedFilters, [filterType]: [] })}
                        size="small"
                        className="ph-chip"
                      />
                    );
                  }


                  // Modify the chips rendering section
                  const selectedChips = selectedFilters[filterType]?.map((value, index) => {
                    const config = filterKeyMap[filterType];
                    if (!config) return null;

                    const item = filterOptions[filterType]?.find(opt => opt[config.idKey] === value);
                    let labelName = typeof config.labelKey === "function" ?
                      config.labelKey(item) : item?.[config.labelKey];

                    // Show first 6 chips or all if expanded
                    if (!showAllChips[filterType] && index >= 6) {
                      return null;
                    }

                    return (
                      <Chip
                        key={`${value}`}
                        label={labelName || value}
                        {...(filterType !== "Exam_Status" && {
                          onDelete: () => handleDeleteChip(filterType, value)
                        })}
                        size="small"
                        className="ph-chip"
                      />
                    );
                  });

                  const moreCount = selectedFilters[filterType]?.length - 6;
                  return (
                    <div className="d-flex flex-wrap gap-2" style={{ maxHeight: showAllChips[filterType] ? 'none' : 'max-content' }}>
                      {selectedChips}
                      {moreCount > 0 && !showAllChips[filterType] && (
                        <Chip
                          label={`+${moreCount} more`}
                          onClick={() => toggleShowAllChips(filterType)}
                          size="small"
                          className="ph-chip"
                        />
                      )}
                      {showAllChips[filterType] && selectedChips.length > 6 && (
                        <Chip
                          label="Show less"
                          onClick={() => toggleShowAllChips(filterType)}
                          size="small"
                          className="ph-chip"
                        />
                      )}
                    </div>
                  );

                  // Otherwise, render individual chips
                  return selectedFilters[filterType]?.map((value) => {
                    const config = filterKeyMap[filterType];
                    if (!config) return null;

                    const item = filterOptions[filterType]?.find(opt => opt[config.idKey] === value);

                    let labelName = "";
                    if (typeof config.labelKey === "function") {
                      labelName = config.labelKey(item);
                    } else {
                      labelName = item?.[config.labelKey];
                    }

                    return (
                      <Chip
                        key={`${value}`}
                        label={labelName || value}
                        {...(filterType !== "Exam_Status" && {
                          onDelete: () => handleDeleteChip(filterType, value)
                        })}
                        size="small"
                        className="ph-chip"
                      />
                    );
                  });
                })()}
              </div>


              <div className={`mb-3 ${isActive ? 'ph-dropdown-highlighted' : ''}`} key={filterType}>
                <button
                  className={`ph-dropdown-btn ${currentDropdown === filterType ? 'active' : ''}`}
                  onClick={(e) => handleOpen(e, filterType)}
                >
                  <span>{filterType}</span>
                  <KeyboardArrowDownIcon />
                </button>

                <Popover
                  open={open && currentDropdown === filterType}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  PaperProps={{ className: 'ph-dropdown-popover' }}
                >
                  <div className="ph-dropdown-header d-flex justify-content-between align-items-center">
                  

                    {currentDropdown !== "Exam_Status" && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              filterOptions[currentDropdown]?.length > 0 &&
                              filterOptions[currentDropdown]?.every(opt => {
                                const config = filterKeyMap[currentDropdown];
                                const value = opt[config.idKey];
                                return selectedFilters[currentDropdown]?.includes(value);
                              })
                            }
                            indeterminate={
                              selectedFilters[currentDropdown]?.length > 0 &&
                              selectedFilters[currentDropdown]?.length < filterOptions[currentDropdown]?.length
                            }
                            onChange={(e) => {
                              const config = filterKeyMap[currentDropdown];
                              if (e.target.checked) {
                                const allValues = filterOptions[currentDropdown]?.map(opt => opt[config.idKey]) || [];
                                setSelectedFilters({
                                  ...selectedFilters,
                                  [currentDropdown]: allValues
                                });
                              } else {
                                setSelectedFilters({
                                  ...selectedFilters,
                                  [currentDropdown]: []
                                });
                              }
                            }}
                            size="small"
                            sx={{
                              color: '#A259FF',
                              '&.Mui-checked': { color: '#A259FF' },
                            }}
                          />
                        }
                        label="Select All"
                      />
                    )}

                    <CloseIcon fontSize="small" onClick={handleClose} style={{ cursor: 'pointer' }} />
                  </div>

                  <div className="ph-dropdown-body">
                    {(filterOptions[filterType] || []).map((option, idx) => {


                      const value =
                        option?.user_id ||
                        option?.grade_id ||
                        option?.language_id ||
                        option?.subject_id ||
                        option?.term_id ||
                        option?.year_id ||
                        option?.source_id ||
                        option?.status_id ||
                        option?.author_id ||
                        option?.chapter_id ||
                        option?.category_id ||
                        option?.exam_category_id ||
                        option?.difficulty_id ||
                        option?.type_id ||
                        option?.exam_status_id;


                      const label =
                        option?.name ||
                        option?.grade ||
                        option?.language ||
                        option?.subject ||
                        option?.term ||
                        option?.year ||
                        option?.source ||
                        option?.status ||
                        option?.author ||
                        option?.chapter ||
                        option?.difficulty_type ||
                        option?.exam_status ||
                        option?.qtype ||
                        `${option.first_name} ${option.last_name}` ||
                        "Unknown";

                       
                       

                      return (
                        <FormControlLabel
                          key={`${value}-${idx}`}
                          control={
                            filterType === "Exam_Status" ?

                              <Radio
                                checked={selectedFilters[filterType]?.includes(value)}
                                onChange={() => handleToggle(filterType, value)}
                                value={value}
                                sx={{
                                  color: '#A259FF',
                                  '&.Mui-checked': {
                                    color: '#A259FF',
                                  },
                                }}
                              />
                              :
                              <Checkbox
                                checked={selectedFilters[filterType]?.includes(value)}
                                onChange={() => handleToggle(filterType, value)}
                                size="small"
                                sx={{
                                  color: '#A259FF',
                                  '&.Mui-checked': {
                                    color: '#A259FF',
                                  },
                                }}
                              />
                          }
                          label={label}
                        />
                      );
                    })}
                  </div>
                </Popover>
              </div>
              <hr className="ph-divider" />
            </>
          );
        })}

    </div>
  );
}
